import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card shadow-sm h-100 photo-tile photo-tile-document" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "card-body p-2 d-flex align-items-center" }
const _hoisted_4 = { class: "small text-muted me-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "photo-tile-thumb",
      title: "Zvětšit",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open')))
    }, [
      _createElementVNode("img", {
        src: _ctx.attachment.url,
        alt: _ctx.attachment.type,
        loading: "lazy"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.order) + ".", 1),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-link text-secondary px-1",
        title: "Zvětšit",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('open')))
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("span", { class: "fas fa-search-plus" }, null, -1)
      ]))]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-link text-danger px-1",
        title: "Smazat",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('remove')))
      }, [...(_cache[4] || (_cache[4] = [
        _createElementVNode("span", { class: "fas fa-trash" }, null, -1)
      ]))])
    ])
  ]))
}